const DISEASES = [
    'NoFinding',
    'SuspectedActiveTB',
    'SuspectedLungMalignancy',
    'AbnormalHeartAndGreatVessels',
    'IntrathoracicAbnormalFindings',
    'ExtrathoracicAbnormalFindings',
    'Pneumonia',
    'Covid19'
]

const COLORS = [
    'rgba(235,255,235,1)',

    // pastel rainbow color
    // 'rgba(213,172,212,1)',
    // 'rgba(181,162,215,1)',
    // 'rgba(153,188,232,1)',
    // 'rgba(146,212,178,1)',
    // 'rgba(195,234,121,1)',
    // 'rgba(225,245,140,1)',
    // 'rgba(239,204,115,1)',
    // 'rgba(238,165,157,1)',
    // 'rgba(236,157,201,1)',

    // warm rainbow color
    // 'rgba(228,28,156,1)',
    'rgba(161,0,155,1)',
    'rgba(105,88,255,1)',
    'rgba(73,211,251,1)',
    'rgba(247,221,0,1)',
    'rgba(251,156,0,1)',
    'rgba(153,76,0,1)',
    'rgba(229,69,94,1)',

]

const COLORS2 = COLORS.map((color) => {
    return color.replace('1)', '0.9)')
})

export const DISEASES_COLORS = DISEASES.map((disease, i) => {
    return {
        disease: disease,
        color: COLORS[i],
        color2: COLORS2[i],
    }
})